import { FileText, CalendarCheck2, Wrench } from "lucide-react";

const steps = [
  {
    n: "01",
    icon: FileText,
    title: "Demandez un devis",
    text: "Par téléphone ou via le formulaire, décrivez-nous votre besoin. Nous vous proposons notre meilleur prix sous 48h ouvrées.",
  },
  {
    n: "02",
    icon: CalendarCheck2,
    title: "Prenez rendez-vous",
    text: "Réservez le créneau qui vous arrange, par téléphone ou e-mail, en fonction de nos disponibilités.",
  },
  {
    n: "03",
    icon: Wrench,
    title: "Réparez votre voiture",
    text: "Notre équipe vous sert dans les plus courts délais, avec un travail soigné et des prix très compétitifs.",
  },
];

export default function Process() {
  return (
    <section
      id="processus"
      data-testid="process-section"
      className="py-24 lg:py-32 bg-slate-50"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mb-16">
          <div className="text-xs font-bold uppercase tracking-[0.2em] text-blue-600 mb-4">
            Notre processus
          </div>
          <h2 className="font-display font-black text-4xl md:text-5xl lg:text-6xl tracking-tighter text-slate-900">
            Réparer votre véhicule en <span className="text-blue-600">3 étapes</span> simples.
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {steps.map((s, i) => (
            <div
              key={s.n}
              data-testid={`process-step-${i + 1}`}
              className="relative bg-white border border-slate-200 rounded-lg p-8 lift hover:shadow-xl hover:border-blue-200"
            >
              <div className="absolute -top-4 -right-2 font-display font-black text-[120px] leading-none text-slate-100 select-none pointer-events-none">
                {s.n}
              </div>
              <div className="relative">
                <div className="h-12 w-12 grid place-items-center rounded-md bg-blue-50 text-blue-600 mb-6">
                  <s.icon size={22} strokeWidth={2} />
                </div>
                <h3 className="font-display font-bold text-xl text-slate-900 mb-3">
                  {s.title}
                </h3>
                <p className="text-slate-600 leading-relaxed text-[15px]">
                  {s.text}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
